export class CompleteGitIntegrationInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "code",
            "baseName": "code",
            "type": "string",
            "format": ""
        },
        {
            "name": "installationId",
            "baseName": "installationId",
            "type": "string",
            "format": ""
        },
        {
            "name": "state",
            "baseName": "state",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CompleteGitIntegrationInput.attributeTypeMap;
    }
    constructor() {
    }
}
